import React from 'react'
import { Link } from 'react-router-dom'
import './LandingPage.css'

const IconSun = () => (
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" stroke="var(--primary)" strokeWidth="1.8" strokeLinecap="round">
    <circle cx="11" cy="11" r="4"/>
    <path d="M11 2v2M11 18v2M2 11h2M18 11h2M4.9 4.9l1.4 1.4M15.7 15.7l1.4 1.4M4.9 17.1l1.4-1.4M15.7 6.3l1.4-1.4"/>
  </svg>
)

const IconBolt = () => (
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" stroke="var(--success2)" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M13 2H7L5 11h6l-2 9 10-12h-6l2-6z"/>
  </svg>
)

const IconTarget = () => (
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" stroke="var(--accent2)" strokeWidth="1.8">
    <circle cx="11" cy="11" r="9"/>
    <circle cx="11" cy="11" r="5"/>
    <circle cx="11" cy="11" r="2" fill="var(--accent2)" stroke="none"/>
  </svg>
)

const IconFounder = () => (
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" stroke="var(--primary)" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 17v-1a5 5 0 0 1 5-5h6a5 5 0 0 1 5 5v1"/>
    <circle cx="11" cy="7" r="4"/>
  </svg>
)

const IconStudent = () => (
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" stroke="var(--primary)" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M2 9l9-6 9 6-9 6-9-6z"/>
    <path d="M20 9v6"/>
    <path d="M6 12.5V17a9 4 0 0 0 10 0v-4.5"/>
  </svg>
)

const IconSales = () => (
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" stroke="var(--primary)" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="22 7 13.5 15.5 8.5 10.5 1 18"/>
    <polyline points="16 7 22 7 22 13"/>
  </svg>
)

const IconHealth = () => (
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" stroke="var(--primary)" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L11 6.67 8.94 4.61a5.5 5.5 0 0 0-7.78 7.78l2.06 2.06L11 22.23l7.78-7.78 2.06-2.06a5.5 5.5 0 0 0 0-7.78z"/>
  </svg>
)

const LaunchRocket = () => (
  <svg className="lp-launch-rocket" viewBox="0 0 96 128" aria-hidden="true">
    <g className="lp-launch-stars">
      <circle cx="18" cy="24" r="1.4" />
      <circle cx="74" cy="18" r="1.2" />
      <circle cx="80" cy="62" r="1" />
      <circle cx="13" cy="72" r="1" />
    </g>
    <g className="lp-rocket-body">
      <path className="lp-rocket-shell" d="M48 9C33 21 28 43 31 67l-13 16 17-4c3 8 9 14 13 17 4-3 10-9 13-17l17 4-13-16C68 43 63 21 48 9Z" />
      <path className="lp-rocket-window" d="M48 35a8 8 0 1 0 0.1 0Z" />
      <path className="lp-rocket-line" d="M36 67h24" />
    </g>
    <g className="lp-flame">
      <path className="lp-flame-outer" d="M37 91c1 15 11 25 11 25s10-10 11-25c-4 5-8 7-11 7s-7-2-11-7Z" />
      <path className="lp-flame-inner" d="M43 93c1 10 5 16 5 16s4-6 5-16c-2 3-4 4-5 4s-3-1-5-4Z" />
    </g>
  </svg>
)

function LandingPage() {
  return (
    <div className="lp">
      {/* Atmospheric orbs */}
      <div className="ambient">
        <div className="orb orb1"></div>
        <div className="orb orb2"></div>
        <div className="orb orb3"></div>
      </div>

      {/* NAV */}
      <nav className="lp-nav">
        <Link to="/" className="lp-brand">
          <div className="lp-brand-icon">R</div>
          <div className="lp-brand-name">Result<span>OS</span></div>
        </Link>
        <Link to="/auth" className="lp-nav-cta">Sign In →</Link>
      </nav>

      {/* HERO */}
      <section className="lp-hero">
        <div className="lp-eyebrow">The Unstoppable System</div>
        <h1 className="lp-hero-h1">
          Most people are busy.<br /><em>Few are unstoppable.</em>
        </h1>
        <p className="lp-hero-sub">
          ResultOS is the daily operating system that makes you unstoppable — one winning result at a time.
        </p>
        <div className="lp-eq-box">
          <span className="lp-eq-text">
            <span className="lp-eq-R">R</span>
            <span className="lp-eq-op"> = (</span>
            <span className="lp-eq-W">W</span>
            <span className="lp-eq-op"> × </span>
            <span className="lp-eq-C">C</span>
            <span className="lp-eq-op">) + </span>
            <span className="lp-eq-T">T</span>
          </span>
        </div>
        <div className="lp-hero-btns">
          <Link to="/auth" className="lp-btn-primary">Become Unstoppable →</Link>
          <a href="#how-it-works" className="lp-btn-ghost">See how it works ↓</a>
        </div>
        <div className="lp-hero-free-note">
          Free forever · No credit card required
        </div>
        <div className="lp-launch-mark">
          <div className="lp-launch-r-logo">R</div>
          <div className="lp-launch-copy">
            <span>Making</span>
            <strong>1 billion people unstoppable</strong>
            <span>— one winning result at a time.</span>
          </div>
        </div>
      </section>

      <div className="lp-divider" />

      {/* THE EQUATION */}
      <div className="lp-section">
        <div className="lp-sec-ey">The Performance Equation</div>
        <h2 className="lp-sec-h2">Three variables.<br /><em>Infinite leverage.</em></h2>
        <p className="lp-sec-sub">
          Every result you produce comes down to three levers. Get all three right and ordinary days become compound days.
        </p>
        <div className="lp-var-grid">
          <div className="lp-var-card">
            <div className="cg-line azure"></div>
            <div className="lp-var-badge azure">W</div>
            <div className="lp-var-name azure">W · Winning Result</div>
            <div className="lp-var-full">Clarity of Goal</div>
            <p className="lp-var-def">
              The one result that makes today a win. Not a task — a clear, measurable, finishable outcome you could hand to someone else. W multiplies everything else.
            </p>
          </div>
          <div className="lp-var-card">
            <div className="cg-line sage"></div>
            <div className="lp-var-badge sage">C</div>
            <div className="lp-var-name sage">C · Concentration</div>
            <div className="lp-var-full">Quality of Focus</div>
            <p className="lp-var-def">
              How deeply and consistently you focused on W. One result. One block. One mind. The same 90 minutes can produce wildly different outcomes depending on C.
            </p>
          </div>
          <div className="lp-var-card">
            <div className="cg-line coral"></div>
            <div className="lp-var-badge coral">T</div>
            <div className="lp-var-name coral">T · Time Protected</div>
            <div className="lp-var-full">Depth of Environment</div>
            <p className="lp-var-def">
              How well you guarded your time from distraction and interruption. One hour of protected time produces more than four hours of scattered effort.
            </p>
          </div>
        </div>
      </div>

      <div className="lp-divider" />

      {/* WHY IT WORKS */}
      <div className="lp-section">
        <div className="lp-sec-ey">Why It Works</div>
        <h2 className="lp-sec-h2">Stop measuring <em>busyness.</em><br />Start measuring results.</h2>
        <div className="lp-two-col">
          <div className="lp-problem-card">
            <div className="lp-problem-title bad">The Problem</div>
            {[
              "Working hard on the wrong thing",
              "Checking messages while in 'deep work'",
              "Switching between 5 tasks and finishing none",
              "Reacting to the loudest priority, not the right one",
              "Ending the day busy but with no clear result",
            ].map((t, i) => (
              <div className="lp-problem-item" key={i}>
                <div className="lp-problem-dot bad"></div>
                <span>{t}</span>
              </div>
            ))}
          </div>
          <div className="lp-problem-card">
            <div className="lp-problem-title good">The ResultOS Difference</div>
            {[
              "Start with the result, not the task list",
              "W multiplies C — clarity amplifies focus",
              "Protected time blocks eliminate task-switching",
              "Honest daily scoring drives consistent improvement",
              "Monthly context keeps every day aligned to what matters",
            ].map((t, i) => (
              <div className="lp-problem-item" key={i}>
                <div className="lp-problem-dot good"></div>
                <span>{t}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="lp-quote">
          <div className="lp-quote-text">
            Do not ask, "How busy was I today?" Ask, "Did I produce the result that mattered?"
          </div>
        </div>
      </div>

      <div className="lp-divider" />

      {/* SCORE EXAMPLES */}
      <div className="lp-section">
        <div className="lp-sec-ey">The Score in Action</div>
        <h2 className="lp-sec-h2">Your day has a <em>number.</em><br />Make it count.</h2>
        <p className="lp-sec-sub">
          The R score doesn't lie. Rate each variable honestly at the end of the day — then use it to improve tomorrow.
        </p>
        <div className="lp-score-grid">
          {/* Average day */}
          <div className="lp-score-card">
            <div className="lp-score-label">Average Day</div>
            <div className="lp-score-vars">
              <div className="lp-score-var">
                <div className="lp-score-var-letter w">W</div>
                <div className="lp-score-var-val w">5</div>
              </div>
              <div className="lp-score-sep">×</div>
              <div className="lp-score-var">
                <div className="lp-score-var-letter c">C</div>
                <div className="lp-score-var-val c">5</div>
              </div>
              <div className="lp-score-sep">+</div>
              <div className="lp-score-var">
                <div className="lp-score-var-letter t">T</div>
                <div className="lp-score-var-val t">5</div>
              </div>
            </div>
            <div className="lp-score-result">
              <div className="lp-score-r-label">R =</div>
              <div className="lp-score-r-val" style={{color:'var(--text2)'}}>30</div>
              <div className="lp-score-r-grade grade-c">C</div>
            </div>
            <div className="lp-score-desc">Some clarity, some focus, some distraction. A day that drifted.</div>
          </div>
          {/* Strong day */}
          <div className="lp-score-card">
            <div className="lp-score-label">Strong Day</div>
            <div className="lp-score-vars">
              <div className="lp-score-var">
                <div className="lp-score-var-letter w">W</div>
                <div className="lp-score-var-val w">8</div>
              </div>
              <div className="lp-score-sep">×</div>
              <div className="lp-score-var">
                <div className="lp-score-var-letter c">C</div>
                <div className="lp-score-var-val c">8</div>
              </div>
              <div className="lp-score-sep">+</div>
              <div className="lp-score-var">
                <div className="lp-score-var-letter t">T</div>
                <div className="lp-score-var-val t">8</div>
              </div>
            </div>
            <div className="lp-score-result">
              <div className="lp-score-r-label">R =</div>
              <div className="lp-score-r-val" style={{color:'var(--success2)'}}>72</div>
              <div className="lp-score-r-grade grade-a">A</div>
            </div>
            <div className="lp-score-desc">Clear result, deep focus, protected time. This is a high-performance day.</div>
          </div>
          {/* Busy but weak */}
          <div className="lp-score-card">
            <div className="lp-score-label">Busy but Weak</div>
            <div className="lp-score-vars">
              <div className="lp-score-var">
                <div className="lp-score-var-letter w">W</div>
                <div className="lp-score-var-val w" style={{color:'var(--error2)'}}>3</div>
              </div>
              <div className="lp-score-sep">×</div>
              <div className="lp-score-var">
                <div className="lp-score-var-letter c">C</div>
                <div className="lp-score-var-val c">8</div>
              </div>
              <div className="lp-score-sep">+</div>
              <div className="lp-score-var">
                <div className="lp-score-var-letter t">T</div>
                <div className="lp-score-var-val t">7</div>
              </div>
            </div>
            <div className="lp-score-result">
              <div className="lp-score-r-label">R =</div>
              <div className="lp-score-r-val" style={{color:'var(--error2)'}}>31</div>
              <div className="lp-score-r-grade grade-c">C</div>
            </div>
            <div className="lp-score-desc">Great focus, wrong target. W=3 destroys everything. This is why W comes first.</div>
          </div>
        </div>
      </div>

      <div className="lp-divider" />

      {/* 3-STEP SYSTEM */}
      <div id="how-it-works" className="lp-section">
        <div className="lp-sec-ey">The Daily System</div>
        <h2 className="lp-sec-h2">Three steps.<br /><em>Every day.</em></h2>
        <p className="lp-sec-sub" style={{marginBottom: '40px'}}>
          The system is simple by design. Complexity is the enemy of consistency.
        </p>
        <div className="lp-steps">
          <div className="lp-step">
            <div className="lp-step-num">01</div>
            <div className="lp-step-icon gold">
              <IconSun />
            </div>
            <div className="lp-step-tag gold">Morning Setup</div>
            <div className="lp-step-title">Define Your W</div>
            <p className="lp-step-body">
              Before the world makes its demands on you, write your single Winning Result. Rate your goal clarity (W score), complete the 5-item ritual checklist, and commit to your first focus block.
            </p>
          </div>
          <div className="lp-step">
            <div className="lp-step-num">02</div>
            <div className="lp-step-icon sage">
              <IconBolt />
            </div>
            <div className="lp-step-tag sage">Focus Blocks</div>
            <div className="lp-step-title">Execute with C &amp; T</div>
            <p className="lp-step-body">
              Run protected deep-work sessions — 90, 60, 45, or 25 minutes. Rate your Concentration (C) and Time Protection (T) in real time. The timer holds you accountable.
            </p>
          </div>
          <div className="lp-step">
            <div className="lp-step-num">03</div>
            <div className="lp-step-icon azure">
              <IconTarget />
            </div>
            <div className="lp-step-tag azure">End-of-Day Score</div>
            <div className="lp-step-title">Review Your R Score</div>
            <p className="lp-step-body">
              Score the day honestly — not emotionally. Calculate your R, earn a grade (S / A / B / C / D), write a reflection, and sync your results to the cloud. History shows the trend.
            </p>
          </div>
        </div>
      </div>

      <div className="lp-divider" />

      {/* WHO IT'S FOR */}
      <div className="lp-section">
        <div className="lp-sec-ey">Who It's For</div>
        <h2 className="lp-sec-h2">Built for anyone who<br /><em>produces results.</em></h2>
        <p className="lp-sec-sub" style={{marginBottom: '40px'}}>
          ResultOS works for any domain where clarity, focus, and protected time determine output.
        </p>
        <div className="lp-role-grid">
          <div className="lp-role-card">
            <div className="lp-role-icon"><IconFounder /></div>
            <div className="lp-role-name">Founder / Executive</div>
            <div className="lp-role-result-label">Monthly Result</div>
            <div className="lp-role-result">"Generate 50 qualified leads for getmyforce AI Agents."</div>
            <div className="lp-role-daily-label">Daily W Example</div>
            <div className="lp-role-daily">Send 20 personalized messages to travel business owners and book 2 discovery calls.</div>
          </div>
          <div className="lp-role-card">
            <div className="lp-role-icon"><IconStudent /></div>
            <div className="lp-role-name">Student</div>
            <div className="lp-role-result-label">Monthly Result</div>
            <div className="lp-role-result">"Complete full revision of Physics Electricity chapter."</div>
            <div className="lp-role-daily-label">Daily W Example</div>
            <div className="lp-role-daily">Solve 40 Current Electricity problems and review every wrong answer.</div>
          </div>
          <div className="lp-role-card">
            <div className="lp-role-icon"><IconSales /></div>
            <div className="lp-role-name">Salesperson</div>
            <div className="lp-role-result-label">Monthly Result</div>
            <div className="lp-role-result">"Build ₹25 lakh qualified pipeline."</div>
            <div className="lp-role-daily-label">Daily W Example</div>
            <div className="lp-role-daily">Call 15 warm leads and schedule 3 demos.</div>
          </div>
          <div className="lp-role-card">
            <div className="lp-role-icon"><IconHealth /></div>
            <div className="lp-role-name">Health &amp; Fitness</div>
            <div className="lp-role-result-label">Monthly Result</div>
            <div className="lp-role-result">"Reduce weight by 2 kg through walking and food discipline."</div>
            <div className="lp-role-daily-label">Daily W Example</div>
            <div className="lp-role-daily">Complete 45-minute walk before breakfast and eat no fried food today.</div>
          </div>
        </div>
      </div>

      {/* FREE FOR EVERYONE BAND */}
      <div className="lp-free-band">
        <div className="lp-free-band-inner">
          <div className="lp-free-badge">FREE</div>
          <div className="lp-free-text">
            <div className="lp-free-headline">Free for everyone. Forever.</div>
            <div className="lp-free-body">
              No plans. No paywalls. No catch. ResultOS is a gift to anyone who wants to perform at their best — founder, student, salesperson, or anyone in between.
            </div>
          </div>
        </div>
      </div>

      {/* CTA STRIP */}
      <div className="lp-cta-strip">
        <h2 className="lp-cta-h2">Stop measuring busyness.<br /><em>Start measuring results.</em></h2>
        <p className="lp-cta-sub">
          Join ResultOS and track your daily R score. Every day you don't measure is a day you can't improve.
        </p>
        <div className="lp-cta-btns">
          <Link to="/auth" className="lp-btn-primary" style={{fontSize: '16px', padding: '18px 44px'}}>
            Create Free Account →
          </Link>
        </div>
        <div className="lp-cta-signin" style={{marginTop: '20px'}}>
          Already have an account?&nbsp;
          <Link to="/auth">Sign in here</Link>
        </div>
      </div>

      {/* FOOTER */}
      <footer className="lp-footer">
        <div className="lp-footer-top">
          <div className="lp-footer-brand">
            <div className="lp-footer-brand-row">
              <div className="lp-brand-icon" style={{width:30,height:30,fontSize:15}}>R</div>
              <div className="lp-brand-name" style={{fontSize:17}}>Result<span>OS</span></div>
            </div>
            <p className="lp-footer-tagline">
              The Unstoppable System for producing real results.
            </p>
            <div className="lp-footer-eq-inline">
              <span className="R">R</span>
              {' = ('}
              <span className="W">W</span>
              {' × '}
              <span className="C">C</span>
              {') + '}
              <span className="T">T</span>
            </div>
          </div>
          <div className="lp-footer-links-col">
            <div className="lp-footer-col-title">Product</div>
            <Link to="/auth" className="lp-footer-link">Sign In</Link>
            <Link to="/auth" className="lp-footer-link">Create Account</Link>
            <a href="#how-it-works" className="lp-footer-link">How It Works</a>
          </div>
          <div className="lp-footer-links-col">
            <div className="lp-footer-col-title">The System</div>
            <a href="#how-it-works" className="lp-footer-link">Morning Setup</a>
            <a href="#how-it-works" className="lp-footer-link">Focus Blocks</a>
            <a href="#how-it-works" className="lp-footer-link">End-of-Day Score</a>
          </div>
          <div className="lp-footer-links-col">
            <div className="lp-footer-col-title">Get Started</div>
            <Link to="/auth" className="lp-footer-cta-sm">Start Free →</Link>
          </div>
        </div>
        <div className="lp-footer-bottom">
          <div className="lp-footer-copy">
            © {new Date().getFullYear()} ResultOS · getmyforce.com · All Rights Reserved.
          </div>
          <div className="lp-footer-legal">
            Built on the principle: <em>R = (W × C) + T</em>
          </div>
        </div>
      </footer>
    </div>
  )
}

export default LandingPage
